export const decodeQuery = (query) => query ? decodeURIComponent(query) : '';